var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 9.45v-2.7C17.875 2.97 14.85 0 11 0S4.125 2.97 4.125 6.75v2.7C1.788 9.45 0 11.205 0 13.5v9.45C0 25.245 1.788 27 4.125 27h13.75C20.212 27 22 25.245 22 22.95V13.5c0-2.295-1.788-4.05-4.125-4.05zm-11-2.7C6.875 4.455 8.662 2.7 11 2.7s4.125 1.755 4.125 4.05v2.7h-8.25v-2.7zm5.5 13.5c0 .81-.55 1.35-1.375 1.35s-1.375-.54-1.375-1.35V16.2c0-.81.55-1.35 1.375-1.35s1.375.54 1.375 1.35v4.05z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconWhite);
export default __webpack_public_path__ + "static/media/lock-icon-white.fe1c258b4e6953e60ce5fddafc774115.svg";
export { ForwardRef as ReactComponent };